class CstmItem extends HTMLElement {
  constructor() {
    super();
    this.minusButton = this.querySelector("[data-minus]");
    this.plusButton = this.querySelector("[data-plus]");
    this.qtyInputElement = this.querySelector(".qty-input div");
    this.qtyInput = parseInt(this.qtyInputElement.textContent) || 1;
    this.productList = this.closest(".ordered-prod-list");
    this.summary = document.querySelector(".totals-details");
    this.id = this.getAttribute("data-id");
    this.isUpdating = false;
  }

  connectedCallback() {
    this.minusButton.addEventListener(
      "click",
      this.handleMinusClick.bind(this)
    );
    this.plusButton.addEventListener("click", this.handlePlusClick.bind(this));
    this.updateButtonStates();
  }

  disconnectedCallback() {
    this.minusButton.removeEventListener(
      "click",
      this.handleMinusClick.bind(this)
    );
    this.plusButton.removeEventListener(
      "click",
      this.handlePlusClick.bind(this)
    );
  }

  handleMinusClick(event) {
    event.preventDefault();
    if (this.isUpdating) return;
    if (this.qtyInput <= 1) return; // Prevent decreasing below 1

    const newQty = this.qtyInput - 1;
    if (this.isValidQuantity(newQty)) {
      this.updateQuantity(newQty);
    }
  }

  handlePlusClick(event) {
    event.preventDefault();
    if (this.isUpdating) return;

    const newQty = this.qtyInput + 1;
    if (this.isValidQuantity(newQty)) {
      this.updateQuantity(newQty);
    }
  }

  isValidQuantity(value) {
    return Number.isInteger(value) && value >= 1;
  }

  updateButtonStates() {
    // Disable minus button when quantity is 1
    if (this.qtyInput <= 1) {
      this.minusButton.classList.add("disabled");
    } else {
      this.minusButton.classList.remove("disabled");
    }
    
    // Update plus button based on inventory (if already has disabled logic)
    // The plus button disabled state is handled in the Liquid template
  }

  updateQuantity(newQty) {
    this.qtyInput = newQty;
    this.qtyInputElement.textContent = newQty;
    this.updateButtonStates();
    this.updateItem(this.id, newQty);
  }

  updateItem(id, newQty) {
    if (!id || !newQty || this.isUpdating) return;

    this.isUpdating = true;
    this.setLoadingState(true);

    console.log(id, newQty);
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: newQty,
      })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((cartData) => {
        return this.refreshCartDisplay();
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
        this.qtyInput = parseInt(this.qtyInputElement.textContent) || 1;
        this.qtyInputElement.textContent = this.qtyInput;
        this.showError("Failed to update cart. Please try again.");
      })
      .finally(() => {
        this.isUpdating = false;
        this.setLoadingState(false);
      });
  }

  refreshCartDisplay() {
    return fetch(window.Shopify.routes.root + "cart?view=ajax", {
      method: "GET",
      headers: {
        Accept: "text/html",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const newProductList = doc.querySelector(".ordered-prod-list");
        const newSummary = doc.querySelector(".totals-details");

        if (newProductList && this.productList) {
          this.productList.innerHTML = newProductList.innerHTML;
        }

        if (newSummary && this.summary) {
          this.summary.innerHTML = newSummary.innerHTML;
        }

        this.reinitializeComponents();
      });
  }

  reinitializeComponents() {
    const newItems = this.productList.querySelectorAll("cstm-item");
    newItems.forEach((item) => {
      if (!customElements.get("cstm-item")) {
        customElements.define("cstm-item", CstmItem);
      }
    });
    // Reinitialize this component's quantity and buttons after refresh
    this.qtyInputElement = this.querySelector(".qty-input div");
    this.qtyInput = parseInt(this.qtyInputElement.textContent) || 1;
    this.minusButton = this.querySelector("[data-minus]");
    this.plusButton = this.querySelector("[data-plus]");
    
    // Reattach event listeners
    if (this.minusButton) {
      this.minusButton.addEventListener("click", this.handleMinusClick.bind(this));
    }
    if (this.plusButton) {
      this.plusButton.addEventListener("click", this.handlePlusClick.bind(this));
    }
    
    this.updateButtonStates();
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.minusButton.style.pointerEvents = "none";
      this.plusButton.style.pointerEvents = "none";
      this.classList.add("updating");
    } else {
      // Only restore pointer events if button is not disabled
      if (!this.minusButton.classList.contains("disabled")) {
        this.minusButton.style.pointerEvents = "auto";
      }
      if (!this.plusButton.classList.contains("disabled")) {
        this.plusButton.style.pointerEvents = "auto";
      }
      this.classList.remove("updating");
      this.updateButtonStates(); // Update button states after loading
    }
  }

  showError(message) {
    console.error(message);
  }
}

if (!customElements.get("cstm-item")) {
  customElements.define("cstm-item", CstmItem);
}
